import { SelectOption } from 'global';
import { FinanceProgramRateType, FinanceProgramType } from '@trnsact/trnsact-shared-types';

import { CreateProposalFinanceExistingOptions } from './types';

export const rateTypeOptions: SelectOption<FinanceProgramRateType>[] = [
  { label: 'Interest Rate', value: FinanceProgramRateType.InterestRate },
  { label: 'Rate Factor', value: FinanceProgramRateType.RateFactor },
];

export const programTypeOptions: SelectOption<FinanceProgramType>[] = [
  { label: 'Loan', value: FinanceProgramType.Loan },
  { label: 'Lease', value: FinanceProgramType.Lease },
  { label: 'EFA', value: FinanceProgramType.Efa },
];

export const existingProgramTypeOptions: SelectOption<CreateProposalFinanceExistingOptions>[] = [
  { label: 'Yes', value: CreateProposalFinanceExistingOptions.Yes },
  { label: 'No', value: CreateProposalFinanceExistingOptions.No },
];
